// Texty přepínače zobrazení hesla — slovenské dvojče locale/cs/passwordToggle.js.
export default {
  show: 'Zobraziť',
  hide: 'Skryť',
  a11yShow: 'Zobraziť heslo',
  a11yHide: 'Skryť heslo',
};
